export default "__VITE_ASSET__BQbhr0FL__"